module.exports = "/assets/data/0d5d389b3a5c2a625bcec01a622ed322-SN13.data.json";